import styled, { css } from 'styled-components'

const BundleContainer = styled.div`
  .bundle {
    &__summary-price {
      display: flex;
      width: 100%;
      align-items: flex-end;
      justify-content: space-between;
      padding-bottom: 10px;
      font-size: 18px;
    }

    &__title {
      width: 90%;
      text-align: center;
      height: 72px;
      overflow: hidden;
      margin-top: 8px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      text-overflow: -o-ellipsis-lastline;
    }
  }
`

const itemCSS = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const Div = styled.div`
  ${itemCSS}
`

const Anchor = styled.a`
  ${itemCSS}
  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    &::before {
      content: '';
      width: 20px;
      height: 20px;
      position: absolute;
      left: -10px;
      top: -10px;
      margin-top: 37.5px;
      background-image: url('//documents.4rgos.it/v1/static/icn-plus');
      background-size: contain;
    }
  }
`

export { BundleContainer, Div, Anchor }
